import React from 'react';
import { getCommonPropsForPropsProvider } from './getCommonPropsForPropsProvider';
import { NotificationCardTitleWithInitiator } from '../NotificationCardTitleWithInitiator';
import { NotificationProfileImageWithBadge } from '../NotificationProfileImageWithBadge';
import { TCloudinaryImageShape } from '../../CloudinaryResponsiveImage/types';
import { COMMENTS_SECTION_ID } from '../../CommentsSection/utils/constants';
import { TNotificationCardPropsProvider } from '../types';
import { LikeBadgeIcon } from '../LikeBadgeIcon';
import { getArticlePageUrl } from '../../../services/pagesUrl/getArticlePageUrl';
import { getPromptPageUrl } from '../../../services/pagesUrl/getPromptPageUrl';

export const newCommentLikePropsProvider: TNotificationCardPropsProvider = ({
  notification,
  sendEvent,
  closeAsidePanel,
}) => {
  const { createdAt, onClick, initiatorName, profileImage } = getCommonPropsForPropsProvider({
    notification,
    sendEvent,
    closeAsidePanel,
  });

  const { relatedComment } = notification;
  const getPageUrl = relatedComment?.article?.type === 'ARTICLE' ? getArticlePageUrl : getPromptPageUrl;

  return {
    createdAt,
    onClick,
    title: <NotificationCardTitleWithInitiator initiatorName={initiatorName} content="liked your comment" />,
    content: relatedComment?.content as string,
    leftAdornment: (
      <NotificationProfileImageWithBadge image={profileImage as TCloudinaryImageShape} badgeIcon={<LikeBadgeIcon />} />
    ),
    url: `${getPageUrl(relatedComment?.article?.slug as string)}#${COMMENTS_SECTION_ID}`,
  };
};
